import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

class LoadingOverlay extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userLoggedIn: false,
      loginname: null,
      userloginid: null,
    };
    this.logoutUser = this.logoutUser.bind(this);
  }

  componentDidMount() {
    this.setUserInfo();
  }

  logoutUser = () => {
    this.setState({ userLoggedIn: false });
    localStorage.clear();
     localStorage.removeItem("userinfo");
this.props.history.push("/login");
  };

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState({
        loginname: userinfo.roleinfo.loginname,
        userloginid: userinfo.roleinfo.userloginid,
        userLoggedIn: true,
      });
    } else {
      return;
    }
  };

  render() {
    return (
      <div>
        {this.props.active && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              width: "100%",
              height: "100%",
              zIndex: 999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#0000002B",
            }}
          >
            {this.props.spinner}
          </div>
        )}
        {this.props.children}
      </div>
    );
  }
}
export default withRouter(LoadingOverlay);
